<p>dashboard-component-list works!</p>
